/**
 * Phase 3a G5 (Issue #1145) — Passkey Settings UI helper.
 *
 * formatLastUsed: ISO datetime을 i18n locale 기반 relative time으로 표시
 * isInactiveCredential: 장기 미사용 credential 판정 (E1 — last_used_at NULL이면 created_at 기준)
 *
 * dayjs 1.11.13의 relativeTime plugin 활용. ko/ja locale 모듈은 side-effect import로
 * 모듈 load 시점에 dayjs에 등록된다 (idempotent).
 *
 * Timezone: backend의 last_used_at은 UTC ISO (datetime.now(UTC).isoformat()).
 * dayjs(iso)가 자동으로 UTC 파싱 + 사용자 로컬 시간대로 fromNow() 계산.
 */
import dayjs from 'dayjs'
import 'dayjs/locale/ja'
import 'dayjs/locale/ko'
import relativeTime from 'dayjs/plugin/relativeTime'

dayjs.extend(relativeTime)

export const INACTIVE_THRESHOLD_DAYS = 90

export function formatLastUsed(t, iso, i18nLang) {
  if (!iso) return t('appConfig.settings.passkeyNeverUsed')
  // dayjs는 invalid 입력에 예외 대신 Invalid Date 객체를 반환 → fromNow()가 "Invalid Date" 문자열로 UI 노출됨.
  // isValid() 명시 분기로 원본 iso 반환 (#1146 review).
  const d = dayjs(iso)
  if (!d.isValid()) return iso
  try {
    const lang = (i18nLang || 'en-US').substring(0, 2)
    return d.locale(lang).fromNow()
  } catch {
    return iso
  }
}

export function isInactiveCredential(cred) {
  // E1: last_used_at이 NULL이면 created_at 기준
  const referenceIso = cred?.last_used_at || cred?.created_at
  if (!referenceIso) return false
  const diffDays = dayjs().diff(dayjs(referenceIso), 'day')
  return diffDays >= INACTIVE_THRESHOLD_DAYS
}
